module.exports = __webpack_public_path__ + "img/VIP-9.a3b615c6.png";